import captionService from 'CaptionService';

export const workflow = {
	auditLogs: {
		close: () => captionService.getString('a6810d4e-882e-480c-a948-8bade715de9d', 'Close'),
		title: () => captionService.getString('68aa4e5a-0e0d-446c-8eca-03b99948e70c', 'Change Logs'),
		summary: () => captionService.getString('706130d6-17f6-42e0-8755-cd98045aad32', 'Summary'),
	}
};
